import {
  Avatar,
  Breadcrumbs,
  Button,
  Card,
  CardActionArea,
  Container,
  Divider,
  Fade,
  Grid,
  Hidden,
  LinearProgress,
  Link,
  makeStyles,
  Tooltip,
  Typography,
  Zoom,
} from "@material-ui/core";
import { blue, green, grey, orange, purple, yellow } from "@material-ui/core/colors";
import { ArrowForward, Description, EmojiEvents, Home, School } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MotionScene, MotionScreen, SharedElement } from "react-motion-layout";
import { useHistory, useParams } from "react-router-dom";
import { withAuthorization } from "../Session";
import * as ROUTES from "../../constants/routes";
import { Skeleton } from "@material-ui/lab";
import ProgressChart from "../HomeScreen/ProgressChart";
import Lottie from "lottie-react";
import CountUp from "react-countup";
import Footer from "../Footer";

const imageUrl = {
  FCSReconocimientoPrecoz: "formation1Image",
  FCSRCPPrecoz: "formation2Image",
  FCSDesfibrilacionPrecoz: "formation3Image",
};

const initialData = [
  { x: 1, y: 0 },
  { x: 2, y: 100 },
];

const CourseModule = (props) => {
  const styles = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const { id } = useParams();
  const { firebase, setModuleView, courseInfo } = props;

  const [formationHover, setFormationHover] = useState(false);
  const [evaluationHover, setEvaluationHover] = useState(false);
  const [courseData, setCourseData] = useState({});
  const [reportData, setReportData] = useState({});
  const [percentData, setpercentData] = useState(initialData);
  const [moduleComplete, setModuleComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    firebase
      .userReport(firebase.currentUser().uid)
      .child(`tests`)
      .once("value")
      .then((snap) => {
        setReportData(snap.val());
      });
    if (id !== undefined) {
      firebase
        .courses()
        .child(`${id}`)
        .once("value")
        .then((snap) => {
          setCourseData({ ...snap.val(), id: id });
          setIsLoading(false);
        });
    }

    window.onpopstate = (e) => {
      e.preventDefault();
      id == undefined ? setModuleView(-1) : history.push(ROUTES.HOME);
      window.scrollTo(0, 0);
    };

    return () => {
      setCourseData({});
    };
  }, []);

  useEffect(() => {
    courseInfo !== undefined &&
      setTimeout(() => {
        setCourseData(courseInfo);
        setIsLoading(false);
      }, 250);
  }, [courseInfo]);

  useEffect(() => {
    if (courseData?.image !== undefined) {
      let meta = reportData[courseData?.testRef]?.metadata;
      let formationPercent = meta?.studed ? 50 : 0;
      let evaluationPercent = meta?.evalApproved ? 50 : (meta?.currentQuestion / meta?.totalQuestions) * 50;
      evaluationPercent = isNaN(evaluationPercent) ? 0 : evaluationPercent;

      let percent = formationPercent + evaluationPercent;
      setpercentData([
        { x: 1, y: percent },
        { x: 2, y: 100 - percent },
      ]);
      if (percent == 100) {
        setTimeout(() => {
          setModuleComplete(true);
          setTimeout(() => {
            setModuleComplete(false);
          }, 1450);
        }, 950);
      }
    }
  }, [courseData, reportData]);

  const evaluationEnabled = reportData[courseData.testRef]?.metadata.studed;

  const handleEvaluation = () => {
    const evaluation = reportData[courseData.testRef]?.metadata;
    if (evaluation.evalApproved) {
      history.push(`/evaluation/result/${evaluation.nAttemps}/${courseData.testRef}/${firebase.currentUser().uid}`);
    } else if (evaluationEnabled) {
      history.push(`/evaluation/${courseData.testRef}`);
    }
  };

  return (
    <MotionScreen>
      <Grid className={styles.mainContainer}>
        <Grid container className={styles.headerContainer}>
          <Container>
            <Breadcrumbs className={styles.breadcrumbs}>
              <Link
                color="inherit"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  id == undefined ? setModuleView(-1) : history.push(ROUTES.HOME);
                  window.scrollTo(0, 0);
                }}
              >
                <div style={{ display: "flex" }}>
                  <Home style={{ paddingBottom: 8, paddingRight: 4 }} />
                  <Typography style={{ paddingTop: 4, textDecoration: "underline" }}>{t("curso_Online")}</Typography>
                </div>
              </Link>

              <Typography color="textPrimary">{t(courseData?.id?.replace("FCS", ""))}</Typography>
            </Breadcrumbs>

            <Grid container justify="center" alignItems="center">
              <Grid item xs={5} md={3} container justify="center">
                {courseData?.image == undefined ? (
                  <Hidden mdDown>
                    <Skeleton variant="circle" height={190} width={190} className={styles.mainImage} />
                  </Hidden>
                ) : (
                  <MotionScene name={`photo-${courseData?.id}`}>
                    <SharedElement.Image className={styles.mainImage} src={t(courseData?.image)} animationKey="image" />
                  </MotionScene>
                )}
              </Grid>
              <Grid item xs={7} md={6}>
                <MotionScene name={`photo-${courseData?.id}`}>
                  <SharedElement.Text animationKey="text" className={styles.mainTitle}>
                    {isLoading ? (
                      <>
                        <Skeleton variant="text" />
                        <Skeleton variant="text" />
                      </>
                    ) : (
                      t(`formation${courseData?.circlePos}Name`)
                    )}
                  </SharedElement.Text>
                </MotionScene>
              </Grid>

              <Hidden mdUp>
                <Card variant="outlined" style={{ padding: 24, marginTop: 24, marginBottom: 24, borderRadius: 9 }}>
                  <Grid item xs={12} container justify="center">
                    <ProgressChart showSuccess={false} data={percentData} percent={percentData[0].y} isCompleted={moduleComplete} isModule />
                  </Grid>
                </Card>
              </Hidden>
              <Hidden mdDown>
                <Grid item xs={12} md={3} container justify="center">
                  <Grid>
                    <Divider orientation="vertical" style={{ marginRight: 16, marginLeft: 16 }} />
                  </Grid>
                  <Grid item xs={8} md={9} container justify="center">
                    {moduleComplete && (
                      <Lottie animationData={require("../../assets/confetti.json")} style={{ height: 240, position: "absolute", zIndex: 10, marginTop: -15, marginRight: 30 }} />
                    )}
                    <ProgressChart showSuccess={false} data={percentData} percent={percentData[0].y} isCompleted={moduleComplete} isModule />
                  </Grid>
                </Grid>
              </Hidden>
            </Grid>
          </Container>
        </Grid>
        <Container style={{ paddingTop: 42 }}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Card
                style={{
                  alignSelf: "center",
                  borderRadius: 9,
                  transition: "all 0.25s ease",
                  transform: formationHover && "translate3D(0,-1px,0) scale(1.03)",
                  boxShadow: formationHover && "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
                  overflow: "hidden",
                }}
                elevation={1}
                onMouseEnter={() => setFormationHover(true)}
                onMouseLeave={() => setFormationHover(false)}
              >
                <CardActionArea style={{ padding: 18 }} onClick={() => history.push(ROUTES.COURSES.replace(":id", courseData.id))}>
                  <Grid container item xs={12} spacing={2} style={{ margin: 0 }}>
                    <Grid item xs={12} md={7} lg={6} container alignItems="center" className={styles.moduleCardTitle}>
                      <Avatar style={{ marginRight: 16, height: 64, width: 64, backgroundColor: purple[500] }}>
                        <School className={styles.moduleCardIcon} />
                      </Avatar>

                      <Typography variant="h4" className={styles.moduleTitle}>
                        {t("repasa_los_conceptos_clave_antes_de_realizar_la_evaluación")}
                      </Typography>
                    </Grid>
                    <Grid item xs={10} md={5} container alignItems="center" justify="center">
                      {evaluationEnabled && <Typography style={{ color: green[500], marginLeft: 16, fontSize: 18 }}>{t("completed!")}</Typography>}
                    </Grid>
                    <Grid item xs={2} md={1} container alignItems="center" justify="flex-end">
                      <ArrowForward />
                    </Grid>
                  </Grid>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Tooltip title={!evaluationEnabled && <Typography>{t("la_evaluación_se_habilitará_una_vez_completada_la_formación")}</Typography>}>
                <Card
                  style={{
                    alignSelf: "center",
                    borderRadius: 9,
                    transition: "all 0.25s ease",
                    backgroundColor: !evaluationEnabled && grey[300],
                    transform: evaluationHover && evaluationEnabled && "translate3D(0,-1px,0) scale(1.03)",
                    boxShadow: evaluationHover && evaluationEnabled && "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
                    overflow: "hidden",
                  }}
                  elevation={!evaluationEnabled ? 0 : 1}
                  onMouseEnter={() => setEvaluationHover(true)}
                  onMouseLeave={() => setEvaluationHover(false)}
                >
                  <CardActionArea style={{ padding: 18 }} disabled={!evaluationEnabled} onClick={handleEvaluation}>
                    <Grid container item xs={12} spacing={2} style={{ margin: 0 }}>
                      <Grid item xs={12} md={7} container alignItems="center" className={styles.moduleCardTitle}>
                        <Avatar style={{ marginRight: 16, height: 64, width: 64, backgroundColor: evaluationEnabled ? blue[500] : grey[200] }}>
                          <Description className={styles.moduleCardIcon} style={{ color: !evaluationEnabled && grey[400] }} />
                        </Avatar>
                        <Typography variant="h4" className={styles.moduleTitle} style={{ color: !evaluationEnabled && grey[600] }}>
                          {t("evalua_los_conocimientos_adquiridos")}
                        </Typography>
                      </Grid>
                      <Grid item xs={10} md={4} container alignItems="center" justify="center" spacing={2}>
                        {percentData[0].y === 100 ? (
                          <>
                            <EmojiEvents style={{ color: yellow[700], fontSize: 32 }} />
                            <Typography style={{ color: green[500], marginLeft: 16, fontSize: 18 }}>{t("completed!")}</Typography>
                          </>
                        ) : reportData[courseData.testRef]?.metadata?.isOnProgress ? (
                          <>
                            <Grid item xs={6} lg={5}>
                              <LinearProgress
                                variant="determinate"
                                value={(reportData[courseData.testRef]?.metadata?.currentQuestion / reportData[courseData.testRef]?.metadata?.totalQuestions) * 100}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <Typography>
                                <CountUp
                                  end={(reportData[courseData.testRef]?.metadata?.currentQuestion / reportData[courseData.testRef]?.metadata?.totalQuestions) * 100}
                                  duration={0.5}
                                />
                                %
                              </Typography>
                            </Grid>
                          </>
                        ) : (
                          <Grid item xs={10} lg={6} contaienr justify="center">
                            <Typography style={{ color: !evaluationEnabled ? grey[600] : orange[500], marginLeft: 16, fontSize: 18 }}>
                              {reportData[courseData.testRef]?.metadata?.isOnProgress
                                ? t("en_proceso")
                                : reportData[courseData.testRef]?.metadata?.nAttemps === -1
                                ? t("evaluacion_no_iniciada")
                                : t("evaluacion_no_superada")}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                      <Grid item xs={2} md={1} container alignItems="center" justify="flex-end">
                        <ArrowForward style={{ color: !evaluationEnabled && grey[600] }} />
                      </Grid>
                    </Grid>
                  </CardActionArea>
                </Card>
              </Tooltip>
            </Grid>
            <Hidden smUp>
              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  fullWidth
                  color="primary"
                  style={{ textTransform: "none", marginTop: 12, borderRadius: 9 }}
                  onClick={() => {
                    id == undefined ? setModuleView(-1) : history.push(ROUTES.HOME);
                    window.scrollTo(0, 0);
                  }}
                >
                  {t("curso_Online")}
                </Button>
              </Grid>
            </Hidden>
          </Grid>
        </Container>
      </Grid>
      <Footer />
    </MotionScreen>
  );
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(CourseModule);

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: grey[100],
    paddingBottom: 64,
  },
  headerContainer: {
    [theme.breakpoints.up("md")]: {
      marginTop: 20,
      paddingTop: 32,
      paddingBottom: 32,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: 12,
      paddingTop: 20,
      paddingBottom: 32,
    },

    backgroundColor: "white",
    zIndex: -1,
    boxShadow: "0px 2px 3px -1px rgb(0 0 0 / 20%), 0 0px 0px rgba(0,0,0,0.24)",
  },
  breadcrumbs: {
    [theme.breakpoints.up("md")]: {
      marginTop: -42,
      marginBottom: 42,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: -20,
      marginBottom: 20,
    },
  },
  mainImage: {
    [theme.breakpoints.up("md")]: {
      height: 190,
    },
    [theme.breakpoints.down("md")]: {
      height: 120,
      paddingRight: 16,
    },
  },
  moduleCardTitle: {
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  },
  moduleCardIcon: {
    [theme.breakpoints.up("md")]: {
      height: 46,
      width: 46,
    },
    [theme.breakpoints.down("md")]: {
      height: 42,
      width: 42,
    },
  },
  moduleTitle: {
    font: "500 18px/28px Google Sans,Arial,sans-serif",
    color: "#3c4043",
    [theme.breakpoints.down("md")]: {
      marginTop: 19,
    },
  },
  moduleCardTitle: {
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  },
  mainTitle: {
    letterSpacing: 0,
    color: "#3c4043",

    marginBottom: 8,
    [theme.breakpoints.up("md")]: {
      font: "400 36px/50px Google Sans,Arial,sans-serif",
      paddingRight: 25,
    },
    [theme.breakpoints.down("md")]: {
      font: "500 22px/28px Google Sans,Arial,sans-serif",
    },
  },
}));
